module.exports = "/call-frontend/img/红.dec3c6e8.png";